export const isImageSrcSVG = (src: string): boolean => {
  const srcArray = src.split('.');
  const extension = srcArray[srcArray.length - 1];
  const svgSupportedFileExtensions = ['svg', 'svgz'];
  return svgSupportedFileExtensions.includes(extension);
};
